import Block from './Block'
import Splide from '@splidejs/splide'
import createDocumentation from '../anims/Documentation'

export default class TwoColumns extends Block {
  getElems() {
    this.sidebarAccordion = this.el.querySelector('.c-sidebar-accordion')
    if (this.sidebarAccordion) {
      this.documentation = {
        el: this.el.querySelector('.c-sidebar-accordion .accordion'),
        chevron: this.el.querySelector('.c-sidebar-accordion .accordion .chevron'),
        cursorStick: this.el.querySelector('.c-sidebar-accordion .accordion .accordion__header__cursor-stick'),
        documents: Array.from(this.el.querySelectorAll('.document')).map((item) => ({
          el: item,
          header: item.querySelector('.document__header'),
          files: item.querySelector('.document__files')
        }))
      }
    }

    this.sidebarSlider = this.el.querySelector('.c-sidebar-slider')
  }

  init() {
    if (this.sidebarAccordion) {
      createDocumentation(this.documentation)
    }

    if (this.sidebarSlider) {
      this.slider = new Splide(this.sidebarSlider.querySelector('.splide'), {
        type: 'loop',
        perPage: '1',
        arrows: true,
        pagination: true,
        classes: {
          arrow: 'splide__arrow pager',
          prev: 'splide__arrow--prev --left',
          next: 'splide__arrow--next --right',
          page: 'dot'
        }
      })

      this.slider.mount()
    }
  }
}
